export enum EProjectTypeId {
    WebDev = "web-dev",
    EmbeddedSystems = "embedded-systems",
    GameDev = "game-dev",
}